import React from 'react';
import { useTranslation } from 'react-i18next';
import { DoughnutChartWithDetail } from '@/components/Charts';
import MetricWithIcon from '@/components/Cards/MetricWithIcon/MetricWithIcon';
import styles from './OccupationCard.module.scss';

interface OccupationCardProps {
  title: string;
  backgroundColor?: string;
  chartstrokecolor?: string;
  metrics: {
    icon: string;
    title: string;
    legend: string;
    metric: string;
    completion: number;
    color: string;
  }[];
}

const OccupationCard: React.FC<OccupationCardProps> = ({
  title,
  metrics,
  backgroundColor,
  chartstrokecolor,
}) => {
  const { t } = useTranslation('dashboardPage');
  return (
    <div style={{ backgroundColor }} className={styles.card}>
      <h2 className={styles.title}>{title}</h2>
      {metrics.length > 2 ? (
        <>
          {' '}
          {metrics.map((metric, index) => (
            <React.Fragment key={metric.icon.toString()}>
              <div className={styles.row}>
                <MetricWithIcon
                  icon={metric.icon}
                  title={metric.title}
                  legend={metric.legend}
                  metric={metric.metric}
                />
                <DoughnutChartWithDetail
                  label=""
                  detail={`${metric.completion}%`}
                  completion={metric.completion}
                  color={metric.color}
                  strokeColor={chartstrokecolor}
                />
              </div>
              {(index === 0 || index === 1) && (
                <div className={styles.divider} />
              )}
            </React.Fragment>
          ))}
        </>
      ) : (
        <p className={styles.emptyText}>{t('terminalPage.no_data')}</p>
      )}
    </div>
  );
};

export default OccupationCard;
